<div class="m-6" rxapStopPropagation>
  <mat-slide-toggle (change)="onChange($event)">
    <span class="mx-2 whitespace-nowrap" i18n>Show archived documents</span>
  </mat-slide-toggle>
</div>
